import {t} from 'i18next';
import {Button} from 'primereact/button';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import InputTextEditorComponent from '../../components/inputs/InputTextEditorComponent';
import EmailService from '../../services/EmailService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import SettingService from '../../services/SettingService';
import InputFileUploadComponent from '../../components/inputs/InputFileUploadComponent';
import FileUploadService from '../../services/FileUploadService';
import EmailDetailsResponse from './EmailDetailsResponse';
import EmailCreateRequest from './EmailCreateRequest';
import StringUtils from '../../utils/StringUtils';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import InputLanguageDropdownComponent from '../../components/inputs/InputLanguageDropdownComponent';

class EmailContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new EmailService());
        this.state = {
            loading: true,
            elementId: props.elementId,
            lang: props.lang,
            supportedLocales: [],
            locale: props.lang,

            emailTypeOptions: [],
            parameters: [],
        };
        this.settingService = new SettingService();
        this.fileUploadService = new FileUploadService();
        this.editorRef = React.createRef();
        this.renderLanguages = this.renderLanguages.bind(this);
        this.reUpdateElement = this.beforeUpdateElement.bind(this);
        this.initAfterSetElement = this.initAfterSetElement.bind(this);
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    updateElement(data) {
        console.log(data, 'data');
        this.setState(
            {
                element: EmailDetailsResponse.copy(this.state.element, data),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId, lang} = this.state;
        this.beforeUpdateElement(viewMode, elementId, lang);
    }

    beforeUpdateElement(viewMode, elementId, lang) {
        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(elementId)
                .then((data) => {
                    this.setState({loading: false, lang: lang}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }

    initBeforeSetElement() {
        this.enumService
            .getLocalizedEnumList('EmailType')
            .then((emailTypeOptions) => {
                this.setState({
                    emailTypeOptions,
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getEmaili18nError'));
            });

        this.settingService
            .getSupportedLocales()
            .then((supportedLocales) => {
                this.setState({
                    supportedLocales,
                    element:
                        this.props.viewMode === 'NEW'
                            ? new EmailCreateRequest(this.props.locale, supportedLocales)
                            : new EmailDetailsResponse(supportedLocales),
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getSupportedLocalesError'));
            });
    }
    initAfterSetElement() {
        let {locale} = this.state;
        if (this.state.element?.translations[locale]?.emailType) {
            this.service
                .getParameters(this.state.element?.translations[locale]?.emailType?.enumValue, locale)
                .then((res) => {
                    this.setState({parameters: res});
                })
                .catch(() => {
                    this.showErrorMessage(t('error.getSettingListParametersError'));
                });
        }
        super.initAfterSetElement();
    }

    prepareFooterItems() {
        const {backUrl, elementId, viewMode} = this.props;

        return [
            {
                label: elementId ? t('email.edit.updateTemplate') : t('email.edit.createTemplate'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.cancel'),
                // href: AppPrefixUtils.locationHrefUrl(backUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray',
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
        ];
    }

    getAddSucces() {
        return t('email.create');
    }

    getUpdateSucces() {
        return t('email.update');
    }

    createOrUpdate() {
        let {element} = this.state;
        const {elementId} = this.state;
        const request = this.prepareElementBeforeRequest(element);
        element.translations = Object.assign({}, element.translations);

        this.scrollToTop();
        if (this._isMounted) {
            if (StringUtils.isBlank(elementId)) {
                this.service
                    .add(request)
                    .then((response) => {
                        this.afterAddSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            } else {
                this.service
                    .update(request)
                    .then((response) => {
                        this.afterUpdateSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            }
        }
    }
    renderHeader() {
        return <React.Fragment>{this.renderLanguages()}</React.Fragment>;
    }

    prepareHeaderItems() {
        return [];
    }

    renderLanguages() {
        return (
            <InputLanguageDropdownComponent
                id='locale'
                name='locale'
                label={t('global.languageChooser')}
                validator={this.validator}
                validators='not_required'
                value={this.state?.locale}
                options={this.state?.supportedLocales}
                colClass='col-lg-2 col-md-3 col-sm-3'
                viewMode={'EDIT'}
                onChange={this.handleChange}
                onAfterStateChange={this.initAfterSetElement}
                rendered
                showClear={false}
                stateField={``}
            />
        );
    }

    getBackLabel() {
        return t('global.backToList');
    }

    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
    getContainerListName() {
        return 'email-list-container';
    }

    breadCrumbItems() {
        return [
            {name: t('email.templates'), url: '/email-template-list'},
            {name: t('email.template'), url: `/email-template/details/${this.state.element?.id}`},
        ];
    }

    renderDetails() {
        let parameterButtonDisabled = !(this.state.parameter != null && this.state.parameter !== undefined);
        const {elementId, locale} = this.state;
        return (
            <React.Fragment>
                <div className='row'>
                    <div className='col-md-6 col-sm-12'>
                        <InputTextComponent
                            id='emailType'
                            name='emailType'
                            label={t('email.type')}
                            colClass='col-md-12'
                            value={this.state.element?.translations[locale]?.emailType?.label}
                            validator={this.validator}
                            validators='required|max:255'
                            onChange={() => {}}
                            viewMode={'VIEW'}
                            stateField={`element.translations[${locale}]`}
                        />
                        <InputTextComponent
                            id='subject'
                            name='subject'
                            label={t('email.subject')}
                            colClass='col-md-12'
                            value={this.state.element?.translations[locale]?.subject}
                            // value={this.state.element.subject}
                            validator={this.validator}
                            validators='required|max:255'
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            stateField={`element.translations[${locale}]`}
                        />
                        <InputTextComponent
                            id='description'
                            name='description'
                            label={t('email.description')}
                            colClass='col-md-12'
                            value={this.state.element?.translations[locale]?.description}
                            validator={this.validator}
                            validators='required|max:255'
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            stateField={`element.translations[${locale}]`}
                        />

                        {this.props.viewMode !== 'VIEW' ? (
                            <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12'>
                                <div className='row'>
                                    <InputDropdownComponent
                                        id='parameter'
                                        name='parameter'
                                        label={t('email.parameter')}
                                        optionLabel='label'
                                        dataKey='enumValue'
                                        validator={this.validator}
                                        validators='not_required'
                                        value={this.state.parameter}
                                        options={this.state.parameters}
                                        colClass='col-lg-6 col-md-12 col-sm-12'
                                        onChange={this.handleChange}
                                        viewMode={this.props.viewMode}
                                        rendered
                                        stateField=''
                                        showClear={false}
                                        valueView={this.state.parameter}
                                    />

                                    <Button
                                        className='p-component email-parameters-button col-lg-6'
                                        colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                                        style={{marginTop: '35px', maxHeight: '35px'}}
                                        label={t('global.insertBtn')}
                                        disabled={parameterButtonDisabled}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            const quill = this.editorRef.current.quill;
                                            const range = quill.getSelection();
                                            const position = range ? range.index : 0;
                                            quill.insertText(position, this.state.parameter.code);
                                        }}
                                    />
                                </div>{' '}
                            </div>
                        ) : null}
                    </div>
                    <InputTextEditorComponent
                        colClass='col-xl-12'
                        id='content'
                        name='content'
                        label={t('email.content')}
                        validator={this.validator}
                        validators={`required`}
                        rows='100'
                        value={this.state.element?.translations[locale]?.content}
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        autoResize
                        stateField={`element.translations[${locale}]`}
                        editorRef={this.editorRef}
                        externalPhotos={true}
                        photos={this.state.element.translations[locale]?.photos}
                        photoUrl={`${this.service.getPath()}/photo/${elementId}`}
                        photoUploadUrl={`${this.fileUploadService.getPath()}/`}
                        photoLabel='fileName'
                        photoName='uuid'
                        uploadFileEnabled
                        handleError={this.onUploladError}
                        restrictExt={false}
                        token={this.authService.getToken()}
                        photoVarName='photos'
                    />
                    <div className='form-group'>
                        <div className='p-label'>
                            <label>{t('email.attachments')}</label>
                        </div>
                        <InputFileUploadComponent
                            messages={this.messages}
                            id='attachments'
                            name='attachments'
                            //label={t('email.attachments')}
                            file={this.state.element?.attachments}
                            showLabel
                            multiple={true}
                            fileList={this.state.element?.attachments}
                            //restApiUrl={`${this.service.getPath()}/${elementId}/attachment`}
                            downloadUrl={`${this.service.getPath()}/${elementId}/attachment`}
                            maxFileSize={50000000}
                            onChange={this.handleChange}
                            itemLabel='fileName'
                            itemName='uuid'
                            colClass='col-xl-12'
                            viewMode={this.props.viewMode}
                            style={{width: '100%'}}
                            handleError={this.onUploladError}
                            token={this.authService.getToken()}
                            validator={this.validator}
                            restrictExt={false}
                            validators='not_required'
                            onAfterStateChange={() =>
                                this.setState({
                                    validationResult: undefined,
                                })
                            }
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

EmailContainer.defaultProps = {
    backUrl: '/email-template-list',
    cancelUrl: '/email-template/details',
    detailUrl: '/email-template/details',
    editUrl: '/email-template/edit',
    // editUrl: '/email-template/edit',
    lazy: true,
};

EmailContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
};

export default withRouter(withTranslation()(EmailContainer));
